/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Organizasyon oluşturma isteği
 * @export
 * @interface RevisdomAPIViewModelsOrganizationCreateOrganizationRequest
 */
export interface RevisdomAPIViewModelsOrganizationCreateOrganizationRequest {
    /**
     * Organizasyon adı
     * @type {string}
     * @memberof RevisdomAPIViewModelsOrganizationCreateOrganizationRequest
     */
    name?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsOrganizationCreateOrganizationRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsOrganizationCreateOrganizationRequest(value: object): value is RevisdomAPIViewModelsOrganizationCreateOrganizationRequest {
    return true;
}

export function RevisdomAPIViewModelsOrganizationCreateOrganizationRequestFromJSON(json: any): RevisdomAPIViewModelsOrganizationCreateOrganizationRequest {
    return RevisdomAPIViewModelsOrganizationCreateOrganizationRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsOrganizationCreateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsOrganizationCreateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function RevisdomAPIViewModelsOrganizationCreateOrganizationRequestToJSON(json: any): RevisdomAPIViewModelsOrganizationCreateOrganizationRequest {
    return RevisdomAPIViewModelsOrganizationCreateOrganizationRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsOrganizationCreateOrganizationRequestToJSONTyped(value?: RevisdomAPIViewModelsOrganizationCreateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

